import React from 'react';
import { connect } from 'react-redux';
import { Modal, Text } from '@simplybenefits/sb-ui-library';
import { resendReviewEmail } from '../../actions/administration';

/**
 *
 * @param changeRequestID
 * @param onClose
 * @param loader
 * @param onClick
 * @param dispatch
 * @returns {JSX.Element}
 * @constructor
 */
const ResendReviewEmailModal = ({ changeRequestID, onClose, loader, dispatch }) => {

    /**
     *
     * @returns {Promise<void>}
     * @private
     */
    const _resendReviewEmail = async () => {
        await dispatch(resendReviewEmail(changeRequestID));
        onClose();
    };

    return (
        <Modal
            open={ true }
            title="Resend Review Email"
            onClose={ onClose }
            loader={ loader }
            primaryButton={{
                color: 'primary',
                label: 'Send Email',
                onClick: _resendReviewEmail
            }}
        >
            <Text medium>Are you sure you want to resend the review email for this change request? This will resend an email of this change request to the admin or member that is required to review it.</Text>
        </Modal>
    );
};

export default connect()(ResendReviewEmailModal);